import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Shared homepage section header: title on the left, a "see all" link on the
 * right. Left-aligned and compact rather than a centred banner — the homepage
 * is a series of merchandising rows, not a sequence of landing sections.
 */
const SectionHeader = ({ title, subtitle, to, linkLabel = "See all" }) => (
  <div className="mb-4 flex items-end justify-between gap-4 border-b border-gray-200 pb-2.5">
    <div>
      <h2 className="text-lg font-bold text-gray-900 sm:text-xl">{title}</h2>
      {subtitle && (
        <p className="mt-0.5 text-[0.8rem] text-gray-500">{subtitle}</p>
      )}
    </div>

    {to && (
      <Link
        to={to}
        className="inline-flex shrink-0 items-center gap-0.5 text-[0.82rem] font-semibold
                   text-[var(--website-primary-color)] hover:underline"
      >
        {linkLabel}
        <ChevronRight size={15} />
      </Link>
    )}
  </div>
);

export default SectionHeader;
